<template>
    <div>

        <template v-if="checked">
            <sau-suspended-service v-if="suspended"></sau-suspended-service>
            <component :is="activeComponent" :service="service" v-else></component>
        </template>

        <template v-else>
            <sau-loading>
                <template slot="message">Fetching Service Summary</template>
            </sau-loading>
        </template>

    </div>
</template>

<script>
import Allocation from './colo/_Allocation';
export default {
    props: ['service'],
    data() {
        return {
            activeComponent: Allocation,
            suspended: false,
            checked: true
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() == 'suspended') {
            this.suspended = true;
        } else {
            // Used for the support sidepanel
            this.$store.commit('setCurrentService', this.service);
        }
        this.checked = true;
    },
    methods: {
    },
    computed: {
    }
}
</script>